(function() {
  // Code-to-package mapping for Norfolk Cannons
  var CODE_MAP = {
    '4CED64B1': '8U',
    '3D57DD56': '9U',
    '6482090E': '10U',
    'F9C58B57': '11U',
    '8DF83BF8': 'Coaches'
  };

  // Also detect from collection URL path as fallback
  var PATH_MAP = {
    '8u-player-package': '8U',
    '9u-player-package': '9U',
    '10u-player-package': '10U',
    '11u-player-package': '11U',
    'coaches-package': 'Coaches'
  };

  function getCodeFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    if (code) {
      code = code.toUpperCase();
      return CODE_MAP[code] || null;
    }
    return null;
  }

  function getPackageFromPath() {
    var path = window.location.pathname.toLowerCase();
    for (var handle in PATH_MAP) {
      if (path.indexOf('/collections/' + handle) !== -1) {
        return PATH_MAP[handle];
      }
    }
    return null;
  }

  function setCartAttribute(pkg) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Team_Package': pkg } })
    }).catch(function() {});
  }

  // Detect package from code param or URL path
  var pkg = getCodeFromUrl() || getPackageFromPath();

  if (pkg) {
    // New package detected - save and set cart attribute
    sessionStorage.setItem('nc_team_package', pkg);
    setCartAttribute(pkg);
  } else {
    // No package in URL - check if we have one stored from earlier navigation
    var stored = sessionStorage.getItem('nc_team_package');
    if (stored) {
      setCartAttribute(stored);
    }
  }
})();